import { Component, OnInit, inject, input } from '@angular/core';
import { GrowInAnimation } from '../../animations/grow.animation';
import { ChatService } from './chat.service';
import { ChatEntry } from './chat-entry.model';
import { ChatEntryComponent } from './chat-entry/chat-entry.component';


@Component({
    selector: 'mulo-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
    host: { class: 'mulo-chat' },
    animations: [GrowInAnimation],
    imports: [ChatEntryComponent]
})
export class ChatComponent implements OnInit {
  private service = inject(ChatService);

  readonly entries = input<Array<any>>(undefined);
  readonly singleInstance = input<boolean>(false);
  readonly reasonPrefix = input('Return reason:');
  chat: ChatEntry[] = [];
  userReply;

  constructor() {
    this.service.singleInstance = this.singleInstance();
    this.service.chatEntries$.subscribe((chat) => {
      this.chat = chat;
    });
  }

  ngOnInit() {
    this.service.populateChat(this.entries());
  }

  addUserMessage() {
    this.service.addUserMessage();
  }
}
